<template>
  <div id="zt598l">
    <div id="k1">
      <div>
        <label>ZT598L</label>
        <label>Over Two Million-Cycle Keyboard Lifetime</label>
        <span>
          <!-- <img :src="require('@/assets/pic/zt598l/icons.png')" /> -->
        </span>
      </div>
      <!-- <img :src="require('@/assets/pic/zt598l/bgcv1.png')" /> -->
    </div>
    <div id="k2">
      <img :src="require('@/assets/pic/zt598l/icon.png')"/>
    </div>
    <div id="k3">
      <div>High Safety Factor</div>
      <div>Attempts fraudulent attacks results in the destruction of secure data</div>
    </div>
    <div id="k4">
      <div>Dimensions</div>
      <div>USB2.0 and RS-232 interfaces</div>
    </div>
    <div id="k5">
      <h5>Application scenarios</h5>
      <div v-for="item in asdata" :key="item.label">
        <img :src="item.pic" />
        <label>{{item.label}}</label>
      </div>
    </div>

    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      asdata: [
        {
          label: 'ATM',
          pic: require('@/assets/pic/zt598l/as1.jpg')
        },
        {
          label: 'The ticket machine',
          pic: require('@/assets/pic/zt598l/as2.jpg')
        },
        {
          label: 'Self-service machine',
          pic: require('@/assets/pic/zt598l/as3.jpg')
        }
      ],
      spdata: {
        file: 'zt598l',
        data: [
          {label: 'Port', desc: ['USB-B×1', 'RJ45×1'], pic: 'port.png'},
          {label: 'Input voltage', desc: ['DC5V±5%'], pic: 'char.png'},
          {label: 'Number of keys', desc: ['Number buttons × 10', 'Function buttons × 6'], pic: 'keyt.png'},
          {label: 'Optional', desc: ['Extended function keyboard', '(scanning method 1×4)'], pic: 'expand.png'},
          {label: 'Compliances', desc: ['ISO,CE,RoHS'],pic: 'stdok.png'},
          {label: 'Protection ability', desc: ['Sensitive data can be kept for', 'more than 5 years during power outage'],pic: 'prtab.png'},
          {label: 'Key Layout', desc: ['Ability to customized layouts'],pic: 'kbchar.png'},
          {label: 'Protection level', desc: ['Static:IP65', 'Dynamic:lP54'],pic: 'prtlv.png'},
          {label: 'EFT', desc: ['Pass the anti-interference test with a repetition frequency of 100KHz and a voltage of 1.0KV'],pic: 'eft.png'},
          {label: 'ESD', desc: ['Withstand electrostatic attack of contact discharge ±6KV，air discharge ±8KV'],pic: 'esd.png'},
          {label: 'Button Pressure', desc: ['2N~5.5N'], pic: 'bpress.png'},
          {label: 'Key material', desc: ['SUS304'], pic: 'keymt.png'},
          {label: 'Dimension(LxWxH)', desc: ['137mm ×88.3mm × 28.5mm'], pic: 'size.png'},
          {label: 'Environment', desc: ['Working temp: 0℃~+50℃', 'Storage temp: -40℃~+70℃', 'Relative humidity: 10%~93%RH(non-condensing)'], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt598l {
  background: black;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt598l/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: .7rem;
}
#k1 div {
  display: inline-block;
  vertical-align: top;
  margin-top: 2.55rem;
  margin-left: 3.72rem;
  /* width: 4.138rem; */
  color: white;
}
#k1 label {
  display: block;
  font-size: .6rem;
  font-weight: bold;
  color: #333333;
}
#k1 label:nth-child(2) {
  font-size: .36rem !important;
  font-weight: 500 !important;
  color: #313333 !important;
  margin-top: .05rem;
  width: 4.31rem;
}


#k2 {
  background: #EEEEEE ;
  text-align: center;
  height: 1.78rem;
  overflow: hidden;
  box-sizing: border-box;
  /* line-height: 1.78rem !important; */
}

#k2 img {
  margin: .55rem auto;
  /* height: .8rem; */
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt598l/bg2.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k3 div:nth-child(1) {
  margin-top: 2.77rem;
  font-size: .58rem;
  font-weight: bold;
  color: #4C4D4C;
}
#k3 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.1rem;
  margin-top: .1rem;
}

#k3 img {
  width: 2.7rem;
  height: 3.89;
  margin-left: 8.4rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt598l/bg3.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  text-align: center;
}
#k4 div:nth-child(1) {
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
  width: 6rem;
  margin: .55rem auto 0 auto;
}
#k4 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.2rem;
  margin: .1rem auto 0 auto;
}

#k5 {
  height: 7rem;
  background:#FAFAFA ;
  text-align: center;
  overflow: hidden;
}
#k5 h5 {
  font-size: .6rem;
  font-weight: bold;
  color: #313333;
  margin: .75rem auto .52rem auto;
}
#k5 div {
  display: inline-block;
  margin: 0 .1rem 0 .1rem;
}
#k5 img {
  display: block;
  height: 2.62rem;
  margin-bottom: .34rem;
}
#k5 label {
  font-size: .32rem;
  font-weight: bold;
  color: #0080CC;
}




</style>
